var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenedMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_12484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9954 14.4738V36.1602C39.9954 37.2729 39.522 38.2745 38.7661 38.9755C38.0807 39.6114 37.163 39.9999 36.155 39.9999H3.83972C2.83172 39.9999 1.91406 39.6114 1.22925 38.9764C0.473632 38.2745 0 37.2729 0 36.1602V14.4738H39.9954Z",
    fill: "#FEC970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9954 14.4738L24.6222 1.67326C21.9427 -0.557876 18.0526 -0.557876 15.3732 1.67326L0 14.4738H0.000305175L4.53124 18.2464L15.3732 27.2738C18.053 29.5056 21.943 29.5056 24.6218 27.2738L35.4647 18.2464L39.9957 14.4738",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4647 6.48528V18.2464L24.6219 27.2738C21.943 29.5056 18.053 29.5056 15.3732 27.2738L4.53125 18.2464V6.48528C4.53125 4.0332 6.51947 2.04498 8.97216 2.04498H31.0244C33.4771 2.04498 35.4647 4.0332 35.4647 6.48528Z",
    fill: "#BFDADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4647 6.48528V15.5527L24.6219 24.5803C21.943 26.8118 18.053 26.8118 15.3732 24.5803L4.53125 15.5527V6.48528C4.53125 4.0332 6.51947 2.04498 8.97216 2.04498H31.0244C33.4771 2.04498 35.4647 4.0332 35.4647 6.48528Z",
    fill: "#E4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2677 37.5079C36.1298 37.5079 35.9909 37.4615 35.8765 37.3663L26.1149 29.2389C25.8552 29.0225 25.8201 28.6364 26.0361 28.3767C26.2525 28.117 26.6385 28.0816 26.8982 28.298L36.6596 36.4251C36.9196 36.6415 36.955 37.0272 36.7386 37.2872C36.6175 37.4328 36.4432 37.5079 36.2677 37.5079Z",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8614 29.255L5.83953 36.1071C4.73418 37.0513 5.22826 38.8558 6.66045 39.1049C8.96422 39.5052 11.6562 39.9545 12.38 39.9999H3.83972C2.83172 39.9999 1.91406 39.6114 1.22925 38.9764C0.473632 38.2745 0 37.2729 0 36.1605V14.4738H2.89856V29.2568C2.92633 32.2451 6.42974 33.8488 8.72649 31.9372L13.0975 28.2977C13.3618 28.0783 13.7576 28.1182 13.9715 28.3917C14.1781 28.655 14.1186 29.0411 13.8614 29.255Z",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9762 17.5705H11.0194C10.6813 17.5705 10.4072 17.2964 10.4072 16.9583C10.4072 16.6205 10.6813 16.3461 11.0194 16.3461H28.9762C29.3144 16.3461 29.5884 16.6205 29.5884 16.9583C29.5884 17.2964 29.3144 17.5705 28.9762 17.5705Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9762 21.1261H11.0194C10.6813 21.1261 10.4072 20.852 10.4072 20.5139C10.4072 20.1758 10.6813 19.9017 11.0194 19.9017H28.9762C29.3144 19.9017 29.5884 20.1758 29.5884 20.5139C29.5884 20.852 29.3144 21.1261 28.9762 21.1261Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9762 10.4599H11.0194C10.6813 10.4599 10.4072 10.1855 10.4072 9.84772C10.4072 9.50958 10.6813 9.23553 11.0194 9.23553H28.9762C29.3144 9.23553 29.5884 9.50958 29.5884 9.84772C29.5884 10.1855 29.3144 10.4599 28.9762 10.4599Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9762 14.0152H11.0194C10.6813 14.0152 10.4072 13.7411 10.4072 13.403C10.4072 13.0649 10.6813 12.7908 11.0194 12.7908H28.9762C29.3144 12.7908 29.5884 13.0649 29.5884 13.403C29.5884 13.7411 29.3144 14.0152 28.9762 14.0152Z",
    fill: "#4B5051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_12484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedMailIcon);
export default __webpack_public_path__ + "static/media/OpenedMailIcon.00040c0fb621f31e76f881a36d1c1602.svg";
export { ForwardRef as ReactComponent };